import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../../consts/api";

export const useAffirmCapabilities = (options = {}) => {
  const res = useQuery(
    [QUERY_KEYS.affirm.getCapabilities],
    () => http.get(HTTP_ENDPOINTS.affirm.getCapabilities()),
    { cacheTime: 0, select: (data) => data.data.data, ...options },
  );

  return res;
};
